import {Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {TypeHelper} from './helper/type-helper.enum';
import {TranslateService} from '@ngx-translate/core';
import {DataTableFiller} from '../../../../../model/data-table-filler';
import {TableModule} from 'primeng/table';

/**
 * Component that handle the list of workflow (also called actionSpace)
 */
@Component({
  selector: 'app-action-and-space-choice',
  templateUrl: './action-and-space-choice.component.html',
  styleUrls: ['./action-and-space-choice.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ActionAndSpaceChoiceComponent implements OnInit, OnChanges {

  /**
   * List of available workflows
   */
  @Input('listOfWorkflows') public listOfWorkflows: any[];

  /**
   * Emitter for the selected space name
   */
  @Output('selectedSpaceName') public selectedSpaceName: EventEmitter<string>;

  /**
   * He only for template access
   */
  public DataTableFiller = DataTableFiller;
  /**
   * List of columns for p-table
   */
  public columns: any[];

  /**
   * Selected workflow inside p-table
   */
  public selectedWorkflow: any;

  /**
   * Workflow column label
   */
  private workFlowColumnLabel: string;

  /**
   * Action kind column label
   */
  private actionKindColumnLabel: string;

  /**
   * Number of documents column label
   */
  private numberOfDocumentsColumnLabel: string;

  /**
   * constructor that instantiate variables
   * @param {TranslateService} translate - handle component translations
   */
  constructor(private translate: TranslateService) {
    this.columns = [];
    this.selectedSpaceName = new EventEmitter<string>();
  }

  /**
   * build columns On component init
   */
  public ngOnInit(): void {
    this.getTradForComponent();
    this.buildColumns();
  }

  /**
   * Called when Input change (which means listOfWorkflows here)
   */
  public ngOnChanges(): void {
    if (this.listOfWorkflows) {
      DataTableFiller.fillAnyArray(this.listOfWorkflows, DataTableFiller.NUMBER_OF_ROWS_FOR_WORKFLOW_LIST, 'sAreaName');
      this.getProperActionType();
    }
    else {
      this.listOfWorkflows = this.DataTableFiller.getEmptyArray(DataTableFiller.NUMBER_OF_ROWS_FOR_WORKFLOW_LIST, 'sAreaName');
    }
    this.selectedWorkflow = null;
  }

  /**
   * build static columns
   */
  public buildColumns(): void {
    this.columns.push({field: 'sAreaName', header: this.workFlowColumnLabel});
    this.columns.push({field: 'sAreaType', header: this.actionKindColumnLabel});
    this.columns.push({field: 'iNbDocsWait', header: this.numberOfDocumentsColumnLabel});
  }

  /**
   * Permit action type translation (generic name are given by default)
   */
  private getProperActionType(): void {
    for (const workflow of this.listOfWorkflows) {

      switch (workflow.sAreaType) {
        case TypeHelper.APPROVAL:
          workflow.sAreaType = 'a';
          break;
        case TypeHelper.GOOD_TO_GO:
          workflow.sAreaType = 'b';
          break;
        case TypeHelper.SIGNATURE:
          workflow.sAreaType = 'c';
          break;
      }
    }
  }

  /**
   * Emit the name of selected workflow (or spaceName)
   * @param {string} selected - name of the selected spaceName
   */
  public emitSelection(selected: string): void {
    this.selectedSpaceName.emit(selected);
  }

  public handleSelectionOfRow(selected: any): any {
    if (!selected.notSelectable) {
      if (this.selectedWorkflow && this.selectedWorkflow.sAreaName === selected.sAreaName) {
        this.selectedWorkflow = null;
        this.emitSelection(null);
      } else {
        this.selectedWorkflow = selected;
        this.emitSelection(selected.sAreaName);
      }
    } else {
      this.selectedWorkflow = null;
    }
  }

  /**
   * obtain translation from TranslateService
   */
  private getTradForComponent(): void {
    this.translate.get('ACTION_AND_SPACE_CHOICE.COMPONENT.WORKFLOW_COLUMN_LABEL').subscribe((res: string) => {
      this.workFlowColumnLabel = res;
    });
    this.translate.get('ACTION_AND_SPACE_CHOICE.COMPONENT.ACTION_KIND_COLUMN_LABEL').subscribe((res: string) => {
      this.actionKindColumnLabel = res;
    });
    this.translate.get('ACTION_AND_SPACE_CHOICE.COMPONENT.NUMBER_OF_DOCUMENTS_COLUMN_LABEL').subscribe((res: string) => {
      this.numberOfDocumentsColumnLabel = res;
    });
  }
}
